define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/constants",
	"csi/switchboard/WidgetMixin",
	"csi/table/Widget",
	"dojo/text!csi/templates/tableSwitchboard.html"
], function(declare, _, constants, WidgetMixin, Widget, template) {

	return declare([Widget, WidgetMixin], {
		allowAutomaticHeight: false,
		tableHeight: constants.TABLE_HEIGHT_SMALL,

		postCreate() {
			// summary: add listener to form data selections and remove suspend mode
			this.plugins = _.without(this.plugins, "tableSuspend");

			if (!this.isPreview) {
				this._switchPostCreate();
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Initialize properties if rendering a switchboard view
		 */
		postMixInProperties() {
			if (!this.isPreview) {
				this.allowChildToScroll = true;
				this.templateString = template;
			}

			this.inherited(arguments);
		},

		preAction(/*Controller*/ac) {
			// summary: if action starting on row, then select the row
			if (this.allowsSelections()) {
				// make sure to get the row's node rather than cell's node (ac.refNode)
				var refNode = ac.refNode && this.getRefNode(ac.refNode);
				if (refNode && !this.isActionRow(refNode)) {
					// if only selecting one, then click is always positive selection; otherwise it acts as toggle
					var fd = this.defView.m_formData;
					var ctx = this.getContext(this.getRefNodeUrl(refNode));
					fd.changeSelection(ctx, true);
				}
			}

			this.inherited(arguments);
		},

		/**
		 * Return true if view contains child views - this will always be the case except when in preview mode (inside custom view dialog)
		 * @return {boolean}
		 */
		isStackedView() {
			return !this.isPreview;
		},

		setViewNode(/*Node*/node, /*Boolean*/bSaveSelections) {
			if (!this.isPreview) {
				this._switchLocationKey();
			}

			this.inherited(arguments);
		},

		_postViewDeferred(/*Context*/ctx, /*Deferred[]*/dfds) {
			// summary: re-create content view, unless printing where views are inserted in _buildViewResults
			this.inherited(arguments);

			if (!this.isPreview) {
				dfds.push(this._switchPostView(ctx));
			}
		},

		_refreshWidget() {
			// summary: hide content view while refreshing
			if (!this.isPreview) {
				this._switchRefresh();
			}

			return this.inherited(arguments);
		}
	});
});